var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 0.899902C2.91194 0.899902 0.399902 3.41194 0.399902 6.4999C0.399902 9.58787 2.91194 12.0999 5.9999 12.0999C9.08787 12.0999 11.5999 9.58787 11.5999 6.4999C11.5999 3.41194 9.08787 0.899902 5.9999 0.899902ZM8.66318 9.39646C8.57218 9.48746 8.45272 9.53326 8.33326 9.53326C8.21381 9.53326 8.09426 9.48746 8.00334 9.39646L5.66998 7.06318C5.58223 6.97594 5.53326 6.85734 5.53326 6.73326V3.6999C5.53326 3.44185 5.74227 3.23326 5.9999 3.23326C6.25753 3.23326 6.46654 3.44185 6.46654 3.6999V6.54006L8.66318 8.73662C8.84562 8.91914 8.84562 9.21403 8.66318 9.39646Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.62d74762.svg";
export { ForwardRef as ReactComponent };